// connectRange's min/max do double duty: they widen its validation window (why
// we set them - see filterWidgets.js) but the connector also treats them as a
// refinement, seeding `>= min`/`<= max` on init, substituting a bound for an
// empty input and reporting the pair in the URL. The dimension and price fields
// are optional: true in the Typesense schema and a numeric filter never matches
// a document missing the field, so a full-range refinement drops every listing
// with no measurement. This keeps the bounds validation-only: refine exactly
// what was typed, and an empty form clears the range.

const toPrecision = (value, round, precision) => {
  const number = parseFloat(value)
  if (!Number.isFinite(number)) return undefined

  const pow = Math.pow(10, precision)
  return round(number * pow) / pow
}

const refinedPair = (state, attribute) => [
  (state.getNumericRefinement(attribute, '>=') || [])[0],
  (state.getNumericRefinement(attribute, '<=') || [])[0]
]

const withFixedBounds = (widgetFactory) => (widgetParams) => {
  const widget = widgetFactory(widgetParams)
  const { attribute, min, max, precision = 0 } = widgetParams

  const refine = (helper) => (values = []) => {
    const [nextMin, nextMax] = [
      toPrecision(values[0], Math.floor, precision),
      toPrecision(values[1], Math.ceil, precision)
    ]
    const [currentMin, currentMax] = refinedPair(helper.state, attribute)
    if (nextMin === currentMin && nextMax === currentMax) return

    let state = helper.state.removeNumericRefinement(attribute)
    if (nextMin !== undefined) state = state.addNumericRefinement(attribute, '>=', nextMin)
    if (nextMax !== undefined) state = state.addNumericRefinement(attribute, '<=', nextMax)
    helper.setState(state.resetPage()).search()
  }

  // Also drops a bound arriving from a legacy ?width_float=0:100000 URL.
  const withoutBounds = (state) => {
    const [refinedMin, refinedMax] = refinedPair(state, attribute)
    let stripped = state
    if (refinedMin === min) stripped = stripped.removeNumericRefinement(attribute, '>=')
    if (refinedMax === max) stripped = stripped.removeNumericRefinement(attribute, '<=')
    return stripped
  }

  return {
    ...widget,
    getWidgetRenderState (renderOptions) {
      return { ...widget.getWidgetRenderState(renderOptions), refine: refine(renderOptions.helper) }
    },
    getWidgetSearchParameters (searchParameters, initOptions) {
      return withoutBounds(widget.getWidgetSearchParameters(searchParameters, initOptions))
    }
  }
}

export { withFixedBounds }
